export enum AlertStatus {
  CLEARED = 'cleared',
  CLOSED = 'closed',
  ACTIVE = 'active',
  INITIATED = 'initiated',
}
